exports = module.exports = require("../../css-loader/dist/runtime/api.js")(false);
// Imports
var getUrl = require("../../css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL___0___ = getUrl(require("./files/untitled-serif-700.woff2"));
var ___CSS_LOADER_URL___1___ = getUrl(require("./files/untitled-serif-700.woff"));
// Module
exports.push([module.id, "@font-face {\n    font-family: 'Untitled serif';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src:\n        url(" + ___CSS_LOADER_URL___0___ + ") format('woff2'), \n        url(" + ___CSS_LOADER_URL___1___ + ") format('woff'); /* Modern Browsers */\n\n}\n", ""]);
